<template>
    <header class="">
        <div class="flex flex-1 flex-col pb-3 pt-2 min-w-0 space-y-4 sm:flex-row sm:items-center sm:pb-5 sm:pt-0 sm:space-y-0">
            <div class="flex-1 px-4 xl:px-0">
                <h1 class="text-gray-800 dark:text-slate-200 text-xl font-bold leading-7 sm:text-2xl">
                    <slot name="heading"></slot>
                </h1>
                <p v-if="hasSubheading" class="text-gray-500 dark:text-slate-500 text-sm font-medium">
                    <slot name="subheading"></slot>
                </p>
            </div>
            <div class="shrink-0 px-4 md:px-0" v-if="hasButton">
                <slot name="button"></slot>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: "Heading",

    computed: {
        hasButton() {
            return !!this.$slots.button
        },

        hasSubheading() {
            return !!this.$slots.subheading
        },
    },
}
</script>
